import axios from 'axios';
import { isIE11 } from 'helpers/ua';

export const CANCELED_CODE = 'CANCELED';
export default function receiveResponse(res, options) {
  const config = {
    id: options.id,
    method: options.method,
    url: options.url,
    timeout: options.timeout,
    headers: options.headers,
  };

  let error = null;

  if (res.stack) {
    error = { message: res.message, stack: res.stack, code: res.code };
  }

  if (res.response) {
    res = res.response;
  }

  const result = res.data || {};
  const headers = res.headers || {};

  let statusCode = res.status;

  // Somehow on IE 11, error is not filled from axios for 409 code
  if (isIE11() && !error && statusCode === 409) {
    error = {
      message: 'Request failed with status code 409',
      stack: 'Request failed with status code 409',
    };
  }
  if (axios.isCancel(res)) {
    statusCode = CANCELED_CODE;
    error = { message: res.message };
  }

  return { config, statusCode, result, headers, error };
}
